<script>

  export default {
    props: {
      copy: {
        type: String,
        required: true,
      },
      displayIcon: {
        type: Boolean,
        default: false,
      },
      iconClass: {
        type: String,
        default: 'status-completed',
      }
    },
  }
</script>

<template>
  <span 
    class="tw-flex align-items-center border rounded-pill block-status status-white pr-2"
    :class="{ 'pl-1': displayIcon, 'pl-2': !displayIcon }">
    <span v-if="displayIcon" class="status-icon" :class="iconClass"></span><span class="status-text tx-weight-bold">{{copy}}</span>
  </span>
</template>
